// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"mQ-z","inlineTitle":"nQ-z","sponsoredAdsWrapper":"oQ-z","marketplaceRecosWrapper":"pQ-z"};